import i18n from '@/helpers/i18n'
import Auth from '@/helpers/authorizations'

/**
 * 菜单结构定义
 * 结构解析：
 * name: 菜单名
 * url: 路由
 * authCode: 权限
 * desc: 描述。会显示在菜单下作为副标，一般把该页面的一些功能罗列即可，避免用户找不到某些功能
 * keywords: 关键词。主要是作为搜索补充使用的
 */
export default [
  // 工作台
  {
    name: i18n.t('new_menu.main.console'),
    menuKey: 'console',
    icon: 'el-icon-s-platform',
    displayMenu: false,
    children: [
      {
        name: i18n.t('new_menu.consoles.dashboard'),
        url: '/dashboard',
        authCode: Auth.showConsoleTodayAnalysis,
        displayMenu: false
      }
    ]
  },
  // 站桩管理
  {
    name: i18n.t('new_menu.main.charging_pile_station'),
    menuKey: 'charging_pile_station',
    icon: 'el-icon-office-building',
    displayMenu: true,
    children: [
      {
        name: i18n.t('new_menu.charging_pile_stations.charging_station'),
        url: '/charge_stations',
        authCode: Auth.listChargeStations,
        desc: i18n.t('new_menu.charging_pile_stations.charging_station_desc'),
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.charging_pile_stations.charge_point'),
        url: '/charge_points',
        authCode: Auth.listChargePoints,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.charging_pile_stations.charger'),
        url: '/chargers',
        authCode: Auth.listChargers,
        desc: i18n.t('new_menu.charging_pile_stations.charging_pile_desc'),
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.charging_pile_stations.billing_rule'),
        url: '/billing_rules',
        authCode: Auth.listBillingRules,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.charging_pile_stations.billing_rule_timer'),
        url: '/billing_rule_timers',
        authCode: Auth.listBillingRuleTimers,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.charging_pile_stations.billing_rule_temperature_timer'),
        url: '/billing_rule_temperature_timers',
        authCode: Auth.listBillingRuleTemperatureTimers,
        displayMenu: false
      },
      {
        name: i18n.t('new_menu.charging_pile_stations.station_comment'),
        url: '/station_comments',
        authCode: Auth.listStationComments,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.charging_pile_stations.station_comment_reply'),
        url: '/station_comment_replies',
        authCode: Auth.listStationComments
      },
      {
        name: i18n.t('new_menu.charging_pile_stations.alarm'),
        url: '/alarms',
        authCode: Auth.listAlarms,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.charging_pile_stations.activity'),
        url: '/station_activities',
        authCode: Auth.listStationActivities,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.charging_pile_stations.magcard_swipe_records'),
        url: '/magcard_swipe_records',
        authCode: Auth.listMagcardSwipeRecords,
        displayMenu: false
      },
      {
        name: i18n.t('new_menu.charging_pile_stations.vin_records'),
        url: '/vin_records',
        authCode: Auth.listVinRecords,
        displayMenu: false
      },
      {
        name: i18n.t('new_menu.charging_pile_stations.inserting_gun_start_records'),
        url: '/inserting_gun_start_records',
        authCode: Auth.listInsertingGunStartRecords,
        displayMenu: false
      },
      {
        name: i18n.t('new_menu.charging_pile_stations.start_appointments'),
        url: '/start_appointments',
        authCode: Auth.listStartAppointments,
        displayMenu: false
      },
      {
        name: i18n.t('new_menu.charging_pile_stations.ev_charging_stations'),
        url: '/ev_charging_stations',
        authCode: Auth.listEvChargingStations,
        keywords: [i18n.t('new_menu.keywords.station')],
        desc: i18n.t('new_menu.charging_pile_stations.ev_charging_stations_desc'),
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.charging_pile_stations.equipment_productions'),
        url: '/equipment_productions',
        authCode: Auth.listEquipmentProductions,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.charging_pile_stations.equipment_dispatch'),
        url: '/equipment_dispatches',
        authCode: Auth.listEquipmentDispatches,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.charging_pile_stations.materials'),
        url: '/materials',
        authCode: Auth.listMaterials,
        displayMenu: true
      }
    ]
  },
  // 交易管理
  {
    name: i18n.t('new_menu.main.transaction'),
    menuKey: 'trade',
    icon: 'el-icon-money',
    displayMenu: true,
    children: [
      {
        name: i18n.t('new_menu.transactions.order'),
        url: '/orders',
        authCode: Auth.listOrders,
        desc: i18n.t('new_menu.transactions.order_desc'),
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.charging_pile_stations.idle_fee_bills'),
        url: '/idle_fee_bills',
        authCode: Auth.listIdleFeeBills,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.transactions.top_up'),
        url: '/top_ups',
        authCode: Auth.listTopUps,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.transactions.withdraw'),
        url: '/withdraw_applications',
        authCode: Auth.listWithdrawApplications,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.transactions.group_topup_withdraw'),
        url: '/group_transaction_records',
        authCode: Auth.listGroupTransactionRecords,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.transactions.point'),
        url: '/point_records',
        authCode: Auth.listPointRecords,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.transactions.charging_card_consumption'),
        url: '/charging_card_consumption_records',
        authCode: Auth.listChargingCardConsumptionRecords,
        displayMenu: true
      }
    ]
  },
  // 用户管理
  {
    name: i18n.t('new_menu.main.user'),
    menuKey: 'user',
    icon: 'el-icon-s-custom',
    displayMenu: true,
    children: [
      {
        name: i18n.t('new_menu.users.user'),
        url: '/users',
        authCode: Auth.listUsers,
        desc: i18n.t('new_menu.users.user_desc'),
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.users.membership'),
        url: '/memberships',
        authCode: Auth.showMembership,
        desc: i18n.t('new_menu.users.membership'),
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.users.car'),
        url: '/cars',
        authCode: Auth.listCars,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.users.magcard'),
        url: '/magcards',
        authCode: Auth.listMagcards,
        desc: i18n.t('new_menu.users.magcard_desc'),
        displayMenu: true
      },
      { name: i18n.t('new_menu.users.message'), url: '/notifications', authCode: Auth.listNotifications, displayMenu: true },
      { name: i18n.t('new_menu.users.feedback'), url: '/feedbacks', authCode: Auth.listFeedbacks, displayMenu: false },
      { name: i18n.t('new_menu.users.virtual_user'), url: '/virtual_users', authCode: Auth.listVirtualUsers, displayMenu: true }
    ]
  },
  // 运营商
  {
    name: i18n.t('new_menu.main.service_provider'),
    menuKey: 'settlement',
    icon: 'el-icon-service',
    displayMenu: true,
    children: [
      {
        name: i18n.t('new_menu.service_providers.service_provider'),
        url: '/service_providers',
        authCode: Auth.listServiceProviders,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.service_providers.ev_charging_station_settlements'),
        url: '/ev_charging_station_settlements',
        authCode: Auth.listEvChargingStationSettlements,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.service_providers.ev_charging_station_daily_settlements'),
        url: '/ev_charging_station_daily_settlements',
        authCode: Auth.listEvChargingStationSettlements,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.applications.service_provider_withdraw'),
        url: '/service_provider_withdraw_applications',
        authCode: Auth.listServiceProviderWithdrawApplications,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.transactions.service_provider_transaction_records'),
        url: '/service_provider_transaction_records',
        authCode: Auth.listServiceProviderTransactionRecords,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.service_providers.charge_channel'),
        url: '/charge_channels',
        authCode: Auth.listChargeChannels
      },
      {
        name: i18n.t('new_menu.service_providers.service_provider_settlement_rule'),
        url: '/settlement_rules',
        authCode: Auth.listSettlementRules,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.service_providers.idle_fee_settlement_rule'),
        url: '/idle_fee_settlement_rules',
        authCode: Auth.showIdleFeeSettlementRule,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.service_providers.discount_settlement_rule'),
        url: '/discount_settlement_rules',
        authCode: Auth.listDiscountSettlementRules,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.service_providers.charging_package_settlement_rule'),
        url: '/charging_package_settlement_rules',
        authCode: Auth.listChargingPackageSettlementRules,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.service_providers.bank_accounts'),
        url: '/bank_accounts',
        authCode: Auth.listBankAccounts,
        displayMenu: true
      }
    ]
  },
  // 审核工单
  {
    name: i18n.t('new_menu.main.application'),
    menuKey: 'application',
    icon: 'el-icon-document-checked',
    displayMenu: true,
    children: [
      { name: i18n.t('new_menu.applications.invoice'), url: '/invoices', authCode: Auth.listInvoices, displayMenu: true },
      {
        name: i18n.t('new_menu.applications.refund'),
        url: '/order_refunds',
        authCode: Auth.listOrderRefunds,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.applications.group_application'),
        url: '/group_applications',
        authCode: Auth.listGroupApplications,
        displayMenu: true
      },
      { name: i18n.t('new_menu.applications.work_orders'), url: '/work_orders', authCode: Auth.listWorkOrders, displayMenu: true }
    ]
  },
  // 通知中心
  {
    name: i18n.t('new_menu.main.notification_center'),
    icon: 'el-icon-bell',
    menuKey: 'notification',
    displayMenu: false,
    children: [
      {
        name: i18n.t('new_menu.notifications.notification_subscriptions'),
        url: '/notification_subscriptions',
        authCode: Auth.listNotificationSubscriptions,
        displayMenu: false
      },
      {
        name: i18n.t('new_menu.notifications.subscription_trigger_records'),
        url: '/subscription_trigger_records',
        authCode: Auth.listSubscriptionTriggerRecords,
        displayMenu: false
      },
      {
        name: i18n.t('new_menu.notifications.alarm_notification_rules'),
        url: '/alarm_notification_rules',
        authCode: Auth.listAlarmNotificationRules,
        displayMenu: false
      }
    ]
  },
  // 报表统计
  {
    name: i18n.t('new_menu.main.report'),
    menuKey: 'report',
    icon: 'el-icon-s-data',
    displayMenu: true,
    children: [
      {
        name: i18n.t('new_menu.reports.order_statistics'),
        url: '/order_statistics',
        authCode: Auth.showOrderStatistics,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.reports.top_up_statistics'),
        url: '/top_up_statistics',
        authCode: Auth.showTopUpStatistics,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.reports.user_overview'),
        url: '/user_statistics',
        authCode: Auth.showUserStatistics,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.reports.my'),
        url: '/reports',
        authCode: Auth.showReport,
        keywords: [i18n.t('new_menu.keywords.report')],
        displayMenu: true
      }
    ]
  },
  // 营销管理
  {
    name: i18n.t('new_menu.main.discount'),
    menuKey: 'marketing',
    icon: 'el-icon-s-marketing',
    displayMenu: true,
    children: [
      {
        name: i18n.t('new_menu.discounts.group'),
        url: '/groups',
        authCode: Auth.listGroups,
        keywords: [i18n.t('new_menu.keywords.discount')],
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.discounts.coupon'),
        url: '/coupon_definitions',
        authCode: Auth.listCouponDefinitions,
        keywords: [i18n.t('new_menu.keywords.discount')],
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.discounts.charging_package'),
        url: '/charging_package_definitions',
        authCode: Auth.listChargingPackageDefinitions,
        keywords: [i18n.t('new_menu.keywords.discount')],
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.discounts.charging_card'),
        url: '/charging_card_definitions',
        authCode: Auth.listChargingCardDefinitions,
        keywords: [i18n.t('new_menu.keywords.discount')],
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.discounts.gift_card'),
        url: '/gift_card_definitions',
        authCode: Auth.listGiftCardDefinitions,
        desc: i18n.t('new_menu.discounts.gift_card_desc'),
        keywords: [i18n.t('new_menu.keywords.discount')],
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.operations.operation_activity'),
        url: '/operation_activities',
        authCode: Auth.listOperationActivities,
        displayMenu: true
      },
      { name: i18n.t('new_menu.operations.task_definition'), url: '/task_definitions', authCode: Auth.listTaskDefinitions, displayMenu: true },
      {
        name: i18n.t('new_menu.operations.discount_activity'),
        url: '/triggers',
        authCode: Auth.listTriggers,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.discounts.settlement_discount'),
        url: '/settlement_discounts',
        authCode: Auth.listSettlementDiscounts,
        keywords: [i18n.t('new_menu.keywords.discount')],
        displayMenu: true
      }
    ]
  },
  // App 基础配置
  {
    name: i18n.t('new_menu.main.operation'),
    menuKey: 'app_setting',
    icon: 'el-icon-x lc-ico-mobile',
    displayMenu: true,
    children: [
      { name: i18n.t('new_menu.operations.app_pages'), url: '/app_pages', authCode: Auth.listAppPages, displayMenu: true },
      { name: i18n.t('new_menu.operations.posts'), url: '/posts', authCode: Auth.listPosts, displayMenu: true },
      { name: i18n.t('new_menu.operations.advertisements'), url: '/advertisements', authCode: Auth.listAdvertisements, displayMenu: true }
    ]
  },
  // 商店管理
  {
    name: i18n.t('new_menu.main.shop'),
    menuKey: 'store',
    icon: 'el-icon-s-shop',
    displayMenu: true,
    children: [
      {
        name: i18n.t('new_menu.shops.products'),
        url: '/products',
        authCode: Auth.listProducts,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.shops.product_orders'),
        url: '/product_orders',
        authCode: Auth.listProductOrders,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.shops.pickup_locations'),
        url: '/pickup_locations',
        authCode: Auth.listPickupLocations
      },
      {
        name: i18n.t('new_menu.shops.product_return_applications'),
        url: '/product_return_applications',
        authCode: Auth.listProductReturnApplications,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.transactions.admin_withdraw'),
        url: '/admin_withdraw_applications',
        authCode: Auth.listAdminWithdrawApplications,
        displayMenu: true
      }
    ]
  },
  // 停车管理
  {
    name: i18n.t('new_menu.main.parking'),
    menuKey: 'parking',
    icon: 'el-icon- lc-ico-car',
    displayMenu: true,
    children: [
      {
        name: i18n.t('new_menu.charging_pile_stations.parking_lock'),
        url: '/parking_locks',
        authCode: Auth.listParkingLocks,
        displayMenu: false
      },
      {
        name: i18n.t('new_menu.charging_pile_stations.nvr_channel'),
        url: '/nvr_channels',
        authCode: Auth.listNvrChannels,
        displayMenu: false
      },
      {
        name: i18n.t('new_menu.charging_pile_stations.parking_reliefs'),
        url: '/parking_reliefs',
        authCode: Auth.listParkingReliefs,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.parkings.parking_relief_records'),
        url: '/parking_relief_records',
        authCode: Auth.listParkingReliefRecords,
        displayMenu: true
      },
      // {
      //   name: i18n.t('new_menu.parkings.parking_relief_codes'),
      //   url: '/parking_relief_codes',
      //   authCode: Auth.listParkingReliefCodes
      // },
      {
        name: i18n.t('new_menu.charging_pile_stations.idle_fees'),
        url: '/idle_fees',
        authCode: Auth.listIdleFees,
        displayMenu: true
      }
    ]
  },

  // 互联互通
  {
    name: i18n.t('new_menu.main.evcs'),
    menuKey: 'evcs',
    icon: 'el-icon-connection',
    displayMenu: true,
    children: [
      {
        name: i18n.t('new_menu.evcs.operator'),
        url: '/evcs_operators',
        authCode: Auth.listEvcsOperators,
        displayMenu: true,
        keywords: [i18n.t('new_menu.keywords.interconnectivity')]
      },
      {
        name: i18n.t('new_menu.evcs.station'),
        url: '/evcs_stations',
        authCode: Auth.listEvcsStations,
        keywords: [i18n.t('new_menu.keywords.station'), i18n.t('new_menu.keywords.interconnectivity')]
      },
      {
        name: i18n.t('new_menu.evcs.connector'),
        url: '/evcs_connectors',
        authCode: Auth.listEvcsConnectors,
        keywords: [i18n.t('new_menu.keywords.interconnectivity')]
      },
      {
        name: i18n.t('new_menu.evcs.order'),
        url: '/evcs_orders',
        authCode: Auth.listEvcsOrders,
        keywords: [i18n.t('new_menu.keywords.discount')]
      },
      {
        name: i18n.t('new_menu.evcs.charge_record'),
        url: '/evcs_charge_records',
        authCode: Auth.listEvcsChargeRecords
      },
      {
        name: i18n.t('new_menu.evcs.ecmp_order'),
        url: '/evcs_ecmp_orders',
        authCode: Auth.listEvcsEcmpOrders,
        keywords: [i18n.t('new_menu.keywords.interconnectivity')],
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.evcs.evcs_notification_order'),
        url: '/evcs_notification_orders',
        authCode: Auth.listEvcsNotificationOrders
      },
      { name: i18n.t('new_menu.evcs.evcs_trace'), url: '/evcs_traces', authCode: Auth.listEvcsTraces }
    ]
  },

  // 系统管理
  {
    name: i18n.t('new_menu.main.system'),
    menuKey: 'system',
    icon: 'el-icon-setting',
    displayMenu: true,
    children: [
      {
        name: i18n.t('new_menu.systems.admin'),
        url: '/admins',
        authCode: Auth.listAdmins,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.systems.role'),
        url: '/roles',
        authCode: Auth.listRoles,
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.systems.charging_pile_setting'),
        url: '/enumerations',
        authCode: Auth.listEnumerations,
        keywords: [i18n.t('new_menu.keywords.setting')]
      },
      {
        name: i18n.t('new_menu.systems.vin_blacklists'),
        url: '/vin_blacklists',
        authCode: Auth.listVinBlacklists,
        keywords: [i18n.t('new_menu.keywords.setting')],
        displayMenu: true
      },
      {
        name: i18n.t('new_menu.systems.system_setting'),
        url: '/system_settings',
        authCode: Auth.listSystemSettings,
        keywords: [i18n.t('new_menu.keywords.setting')]
      },
      { name: i18n.t('new_menu.systems.tag'), url: '/tags', authCode: Auth.listTags },
      { name: i18n.t('new_menu.systems.model_version_log_audits'), url: '/model_version_log_audits', authCode: Auth.listModelVersionLogAudits },
      { name: i18n.t('new_menu.systems.third_party_service_traces'), url: '/third_party_service_traces', authCode: Auth.listThirdPartyServiceTraces }
    ]
  }
]
